const DAY_MS = 24 * 60 * 60 * 1000;
const DEFAULT_CHUNK_MS = 3 * DAY_MS;
const TRUNCATED_RESULT_COUNT = 3000;

/** A date-only selection means the whole day, through 23:59:59. */
export function inclusiveHistoryEnd(dateStr) {
  if (dateStr == null || dateStr === '') return dateStr;
  const raw = String(dateStr).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return `${raw}T23:59:59`;
  return raw;
}

export function historyRangeChunks(startMs, endMs, chunkMs = DEFAULT_CHUNK_MS) {
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || endMs <= startMs) return [];
  const chunks = [];
  let cursor = startMs;
  while (cursor < endMs) {
    const next = Math.min(endMs, cursor + chunkMs);
    chunks.push([cursor, next]);
    cursor = next;
  }
  return chunks;
}

const COVERAGE_SLACK_MS = 2 * 60 * 60 * 1000;
const MIN_PROFILES_FOR_TRUNCATED_EDGE = 100;

export function historyResponseLooksTruncated(profiles, startMs, endMs) {
  if (!Array.isArray(profiles) || profiles.length < TRUNCATED_RESULT_COUNT) return false;
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return false;
  return endMs - startMs > 6 * 60 * 60 * 1000;
}

/** Edges of the requested window that a capped history page did not cover. */
export function historyUncoveredEdges(profiles, startMs, endMs) {
  if (!Array.isArray(profiles) || profiles.length < MIN_PROFILES_FOR_TRUNCATED_EDGE) return [];
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || endMs <= startMs) return [];

  let min = Infinity;
  let max = -Infinity;
  profiles.forEach((profile) => {
    const time = new Date(profile?.datetime_fetched).getTime();
    if (!Number.isFinite(time)) return;
    if (time < min) min = time;
    if (time > max) max = time;
  });
  if (!Number.isFinite(min) || !Number.isFinite(max)) return [];

  const edges = [];
  if (min - startMs > COVERAGE_SLACK_MS) edges.push([startMs, min]);
  if (endMs - max > COVERAGE_SLACK_MS) edges.push([max, endMs]);
  return edges;
}

export function profileHistoryKey(profile) {
  if (profile?.id != null) return `id:${profile.id}`;
  return `t:${profile?.datetime_fetched ?? ''}|l:${profile?.level ?? ''}`;
}

export function mergeProfileHistory(groups) {
  const seen = new Set();
  const merged = [];
  groups.forEach((group) => {
    (group || []).forEach((profile) => {
      const key = profileHistoryKey(profile);
      if (seen.has(key)) return;
      seen.add(key);
      merged.push(profile);
    });
  });
  return merged;
}
